import { createTheme } from '@mui/material/styles'
import { baseTheme } from './baseTheme'

export const lightTheme = createTheme({
  ...baseTheme,
  ...{
    palette: {
      background: {
        primary: '#FFFFFF',
        secondary: '#F4F4F4',
        terciary: '#FFFFFF',
        disabled: '#E0E0E0',
        dark: '#393939'
      },

      button: {
        hover: '#f5f5f5'
      },

      text: {
        primary: '#000000',
        secondary: '#6F6F6F',
        terciary: '#A8A8A8',
        light: '#FFFFFF'
      },

      primary: {
        light: '#D6EBEA',
        main: '#008F83',
        dark: '#006A61'
      },

      secondary: {
        light: '#FFF8E9',
        main: '#F1C045',
        dark: '#D39D11'
      },

      error: {
        main: '#B40A36',
        dark: '#7A0428',
        light: '#F5CFD7'
      },

      success: {
        main: '#69BE28',
        dark: '#2D8709',
        light: '#DDF4CC'
      },

      warning: {
        main: '#E5B22D',
        dark: '#B57802',
        light: '#FCEFCF'
      },

      border: {
        primary: '#F4F4F4',
        secondary: '#E0E0E0',
        terciary: '#008F83'
      },

      overlay: 'rgba(0, 0, 0, 0.4)',
      typeColor: {
        primary: '#393939',
        secondary: '#6F6F6F',
        terciary: '#A8A8A8',
        light: '#FFFFFF'
      },

      gray: {
        primary: '#E0E0E0',
        secondary: '#E0E0E0'
      },

      teal: {
        hover: '#EDFAF8',
        select: '#B7DDDB',
        primary: '#007D73'
      },

      yellow: {
        hover: '#F9E0A1',
        select: '#F9D787',
        primary: '#D39D11'
      },

      red: {
        hover: '#F9E6EB',
        select: '#F0B2BD',
        primary: '#9C0133'
      },

      green: {
        hover: '#EBFAE0',
        select: '#D2EEBC',
        primary: '#58AA1F'
      }
    }
  }
})
